export default "__VITE_ASSET__BGcIWm36__"